import { Injectable } from '@angular/core';
import {
  IrisProductGQL,
  IrisProductQuery,
  IrisProductQueryVariables,
  UpdateIrisFbaGQL,
  UpdateIrisFbaMutation,
  UpdateIrisFbaMutationVariables,
  UpdateIrisMemoGQL,
  UpdateIrisMemoMutation,
  UpdateIrisMemoMutationVariables,
  UpdateOrderLevelGQL,
  UpdateOrderLevelMutation,
  UpdateOrderLevelMutationVariables,
} from 'src/gql/generated';
import { HttpService } from './http.service';
import { gqlErrors } from 'src/app/utils/gql-errors';

@Injectable({
  providedIn: 'root',
})
export class IrisService {
  constructor(
    private http: HttpService,
    private irisProductGQL: IrisProductGQL,
    private updateOrderLevelGQL: UpdateOrderLevelGQL,
    private updateMemoGQL: UpdateIrisMemoGQL,
    private updateIrisFbaGQL: UpdateIrisFbaGQL,
  ) {}

  public async fetchProducts(body: IrisProductQueryVariables, success: (resp: IrisProductQuery) => void, error?: any) {
    const resp = await this.irisProductGQL.fetch({ variables: body, fetchPolicy: 'network-only' }).toPromise();

    if (gqlErrors(resp)) {
      if (this.http.hasExtensions(gqlErrors(resp))) {
        error(gqlErrors(resp)[0].extensions);
      } else {
        this.http.handleError();
      }
    } else {
      success(resp.data);
    }
  }

  public async updateOrderLevel(
    body: UpdateOrderLevelMutationVariables,
    success: (resp: UpdateOrderLevelMutation) => void,
    error?: any,
  ) {
    const resp = await this.updateOrderLevelGQL.mutate({ variables: body }).toPromise();

    if (gqlErrors(resp)) {
      if (this.http.hasExtensions(gqlErrors(resp))) {
        error(gqlErrors(resp)[0].extensions);
      } else {
        this.http.handleError();
      }
    } else {
      success(resp.data);
    }
  }

  public async updateMemo(
    body: UpdateIrisMemoMutationVariables,
    success: (resp: UpdateIrisMemoMutation) => void,
    error?: any,
  ) {
    const resp = await this.updateMemoGQL.mutate({ variables: body }).toPromise();

    if (gqlErrors(resp)) {
      if (this.http.hasExtensions(gqlErrors(resp))) {
        error(gqlErrors(resp)[0].extensions);
      } else {
        this.http.handleError();
      }
    } else {
      success(resp.data);
    }
  }

  public async updateFba(
    body: UpdateIrisFbaMutationVariables,
    success: (resp: UpdateIrisFbaMutation) => void,
    error?: any,
  ) {
    const resp = await this.updateIrisFbaGQL.mutate({ variables: body }).toPromise();

    if (gqlErrors(resp)) {
      if (this.http.hasExtensions(gqlErrors(resp))) {
        error(gqlErrors(resp)[0].extensions);
      } else {
        this.http.handleError();
      }
    } else {
      success(resp.data);
    }
  }
}
